<template>
  <div :id="modalId" class="modal fade" tabindex="-1" aria-hidden="true" :aria-labelledby="`${modalId}-title`">
    <div class="modal-dialog modal-dialog-centered options-menu-dialog">
      <div class="modal-content options-menu">
        <div class="options-menu__header">
          <h5 :id="`${modalId}-title`" class="options-menu__title">{{ title }}</h5>
          <button type="button" class="btn-close btn-close-white options-menu__close" data-bs-dismiss="modal" :aria-label="$t('shared.close')"></button>
        </div>
        <div class="options-menu__body">
          <slot></slot>
        </div>
        <div v-if="$slots.footer" class="options-menu__footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// The frame shared by the map Options dialogs (MapOptionsDialog and the planner's Options),
// drawn as the apps' options sheet (Android OptionsSheetTiles.kt / MapOptionsSheet.kt, iOS
// options sheets): sections of two-up grey tiles (OptionsMenuSection + OptionsMenuTile), and an
// optional link at the foot (OptionsMenuFooterLink). Trello #1096.
defineProps({
  modalId: { type: String, required: true },
  title: { type: String, required: true },
});
</script>

<style scoped>
.options-menu-dialog {
  max-width: 460px;
}

/* The apps' sheet base (background_base_dark). */
.options-menu {
  padding: 8px 16px 12px;
  background: #17181d;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);
}

.options-menu__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0 14px;
}

.options-menu__title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #fff;
}

.options-menu__close {
  width: 10px;
  height: 10px;
  padding: 6px;
  background-size: 10px;
  opacity: 0.6;
}

.options-menu__close:hover {
  opacity: 1;
}

/* Clear room between sections, so each title reads as starting a new group. */
.options-menu__body {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.options-menu__footer {
  margin-top: 14px;
}
</style>
